/**
 * useApiClient Hook
 * Provides access to the typed API client within React components
 * Uses centralized API configuration
 */

import { createApiClient } from '../../config/apiConfig';
import type { ApiClient } from '../../api/ApiClient';

export const useApiClient = (): ApiClient<unknown> => {
  // Return centrally configured API client
  return createApiClient();
};